import { FCX, ID } from "@datassential/platform-ui-lib";
import { ReactNode } from "react";
import cn from "classnames";
import './ChartTabs.scss';

export interface ITab {
    id: ID;
    name: ReactNode;
}

const FoodChartTabs: FCX<{
    data: ITab[];
    activeItemIndex: ID;
    setActiveItemIndex: (index: number) => void;
}> = ({
    data,
    activeItemIndex,
    setActiveItemIndex,
}) => {
    return (
        <div
            className="FoodChartTabs"
            data-testid="blockFoodSummaryChartTabs"
        >
            {data.map((item, index) => (
                <button
                    key={item.id}
                    type="button"
                    className={cn(
                        "FoodChartTabs__item",
                        index === activeItemIndex && ' is-active',
                    )}
                    aria-pressed={index === activeItemIndex}
                    data-testid="buttonFoodSummaryChartTabsItem"
                    onClick={() => setActiveItemIndex(index)}
                >
                    {item.name}
                </button>
            ))}
        </div>
    );
};

export default FoodChartTabs;